import React from 'react';
import { Checkbox as Chbx } from 'antd';

/**
 * A styled checkbox
 *
 * {@link https://ant.design/components/checkbox#api}
 *
 * @module Checkbox
 * @param {Object} props - The component props
 * @param {Object} [props.children] - the children to render in the checkbox
**/
const Checkbox = ( { children, ...props } ) => {
    return (
        <Chbx { ...props }>{ children }</Chbx>
    );
};

const Group = ( { ...props } ) => (
    <Chbx.Group { ...props } />
);

Checkbox.Group = Group;

export { Checkbox };
